import { action } from 'typesafe-actions';
import { Types, IFabricationMockup, IPavement } from './types';

export const saveMockup = (
  contractNumber: string,
  mockupName: string,
  hasRoof: boolean,
  hasCovering: boolean,
  typicalFloorPlan: string,
  otherTypicalFloorPlan: string,
  pavements: IPavement[],
  mockupId?: number
) =>
  action(Types.SAVE_FABRICATION_MOCKUP, {
    contractNumber,
    mockupName,
    hasRoof,
    hasCovering,
    typicalFloorPlan,
    otherTypicalFloorPlan,
    pavements,
    mockupId
  });
export const saveMockupSuccess = (createdMockup?: IFabricationMockup) =>
  action(Types.SAVE_FABRICATION_MOCKUP_SUCCESS, { createdMockup });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveMockupFailure = (error: any, contractError?: boolean) =>
  action(Types.SAVE_FABRICATION_MOCKUP_FAILURE, { error, contractError });

export const setEditingMockup = (mockupId?: number) =>
  action(Types.SET_EDITING_MOCKUP, { mockupId });

export const loadMockups = (contractNumber: string) =>
  action(Types.LOAD_FABRICATION_MOCKUPS, { contractNumber });
export const loadMockupsSuccess = (mockups: IFabricationMockup[]) =>
  action(Types.LOAD_FABRICATION_MOCKUPS_SUCCESS, { mockups });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMockupsFailure = (error: any, contractError?: boolean) =>
  action(Types.LOAD_FABRICATION_MOCKUPS_FAILURE, { error, contractError });

export const removeMockup = (mockupId: number, contractNumber: string) =>
  action(Types.REMOVE_FABRICATION_MOCKUPS, { mockupId, contractNumber });
export const removeMockupSuccess = () =>
  action(Types.REMOVE_FABRICATION_MOCKUPS_SUCCESS);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeMockupFailure = (error: any, contractError?: boolean) =>
  action(Types.REMOVE_FABRICATION_MOCKUPS_FAILURE, { error, contractError });

export const editPavement = (
  contractNumber: string,
  pavement: IPavement,
  mockupId: number
) =>
  action(Types.EDIT_PAVEMENT_STATUS, {
    contractNumber,
    pavement,
    mockupId
  });
export const editPavementSuccess = (pavementId: number) =>
  action(Types.EDIT_PAVEMENT_STATUS_SUCCESS, { pavementId });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const editPavementFailure = (error: any) =>
  action(Types.EDIT_PAVEMENT_STATUS_FAILURE, { error });
